<template>
  <gral-theme-one/>
</template>

<script>
import gralThemeOne from '../../../components/faq/general-theme-one'
export default {
  name: 'GeneralThemeOneView',
  components: {
    gralThemeOne
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/faq/general-theme-one.view.vue